import { motion } from "framer-motion";

// Masked line-by-line reveal. Pass an array of strings (lines).
export const LineReveal = ({ lines, className = "", delay = 0, stagger = 0.09 }) => {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-line">
          <motion.span
            className="block"
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 0.9,
              ease: [0.16, 1, 0.3, 1],
              delay: delay + i * stagger,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

// Scroll-triggered fade/slide-in wrapper.
export const Reveal = ({ children, className = "", delay = 0, y = 40, once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.75, ease: [0.16, 1, 0.3, 1], delay }}
  >
    {children}
  </motion.div>
);
